import GoogleAnalytics from "../../googleAnalytics";
import { RemoveFromWishlist, SelectItem } from "../../types";
import {
  AddProductToCart,
  AddProductToWishlist,
  OutofStock,
  PaymentMethodInfo,
  SelectProductSize,
  ShareProduct
} from "./type";

class PdpAnalyticsService {
  addToCart(payload: AddProductToCart) {
    GoogleAnalytics.addToCart(payload);
  }
  addToWishlist(payload: AddProductToWishlist) {
    //@ts-ignore
    GoogleAnalytics.addToWishlist(payload);
  }
  removeFromWishlist(payload: RemoveFromWishlist) {
    GoogleAnalytics.removeFromWishlist(payload);
  }
  share(payload: ShareProduct) {
    GoogleAnalytics.shareProduct(payload);
  }
  selectSize(payload: SelectProductSize) {
    GoogleAnalytics.selectSize(payload);
  }
  outOfStock(payload: OutofStock) {
    GoogleAnalytics.outOfStock(payload);
  }
  paymentMethodInfo(payload: PaymentMethodInfo) {
    GoogleAnalytics.paymentMethodInfo(payload);
  }
  select(payload: SelectItem) {
    GoogleAnalytics.selectProduct(payload);
  }
}

const PdpAnalyticsEvent = new PdpAnalyticsService();
export default PdpAnalyticsEvent;
